import {getRequest, saveRequest} from '@requests/index';
import {addNotification} from '@componentDP/js_react/redux/actions/application';
import {has} from 'lodash';
import {store} from '../store';
import {SET_TWO_FACTOR_LOGIN, SETTINGS_PAGE_LOADED} from '../store/actionTypes';

export function settingsPageInit() {
    return async (dispatch) => {
        const {apiDomainAuth} = store.getState();
        dispatch(setSettingsPageLoaded(false));
        const result = await getRequest(`${apiDomainAuth}api/profile_applicant/two_factor/status`);
        if (typeof result.status === 'undefined' || !result.status || !has(result, 'data.two_factor_enabled')) {
            dispatch(addNotification({message: 'Произошла ошибка на стороне сервера', type: 'error'}));
        } else {
            dispatch(setTwoFactorLogin(result.data.two_factor_enabled));
        }
        dispatch(setSettingsPageLoaded(true));
    };
}

export function changeTwoFactorLoginStatus(status) {
    return async (dispatch) => {
        const {apiDomainAuth} = store.getState();
        const apiPostfix = status ? 'enable' : 'disable';
        const result = await saveRequest(`${apiDomainAuth}api/profile_applicant/two_factor/${apiPostfix}`, {});
        if (typeof result.status === 'undefined' || !result.status) {
            dispatch(addNotification({message: 'Произошла ошибка на стороне сервера', type: 'error'}));
        } else {
            dispatch(setTwoFactorLogin(status));
        }
    };
}

export function setSettingsPageLoaded(status) {
    return {
        type: SETTINGS_PAGE_LOADED,
        status,
    };
}

export function setTwoFactorLogin(status) {
    return {
        type: SET_TWO_FACTOR_LOGIN,
        status,
    };
}
